import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { EmailCredentialVerificationService } from '../../../shared/services/email-credential-verification.service';
import { combineLatest, map, Observable, startWith } from 'rxjs';
import { ValidationCheckStatus } from '../../../shared/types';

@Component({
  selector: 'app-email-account-client-settings',
  templateUrl: './email-account-client-settings.component.html',
  styleUrls: ['./email-account-client-settings.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class EmailAccountClientSettingsComponent implements OnInit {
  constructor(private credentialVerificationService: EmailCredentialVerificationService) {}

  @Input() SMPTSettingsGroup: FormGroup<any>;
  @Input() IMAPSettingsGroup: FormGroup<any>;

  $formInvalid: Observable<boolean>;
  $connectionVerificationStatus: Observable<ValidationCheckStatus>;

  ngOnInit(): void {
    this.$connectionVerificationStatus =
      this.credentialVerificationService.getCredentialVerificationStatus$();

    this.$formInvalid = combineLatest([
      this.SMPTSettingsGroup.valueChanges.pipe(startWith(null)),
      this.IMAPSettingsGroup.valueChanges.pipe(startWith(null)),
    ]).pipe(
      map(() => {
        return this.SMPTSettingsGroup.invalid || this.IMAPSettingsGroup.invalid;
      }),
    );
  }

  verifyConnection(): void {
    this.credentialVerificationService.checkConnection();
  }
}
